import Joi from "joi";

// FIX: removed 'errors' param — now uses functional setErrors(prev => ...)
// to avoid an infinite loop when 'errors' was included in useEffect dep arrays.
export const validateProperty = (property, schemaObj, setErrors) => {
  const { name, value } = property;

  const schema = Joi.object({
    [name]: schemaObj[name],
  });

  const { error } = schema.validate({ [name]: value });

  setErrors((prev) => {
    const next = { ...prev };
    if (error) {
      next[name] = error.details[0].message;
    } else {
      delete next[name];
    }
    return next;
  });
};

export const validateForm = (data, schemaObj) => {
  const schema = Joi.object(schemaObj);

  const options = { abortEarly: false };
  const { error } = schema.validate(data, options);
  if (!error) return null;

  return error;
};
